/**
 * Сохранение позиции воспроизведения видео из раздела «Тренинги».
 * Использует localStorage (работает на веб и в Capacitor).
 */
const STORAGE_PREFIX = 'liga-edu-video-pos-';

function storageKey(videoId: string): string {
  return `${STORAGE_PREFIX}${videoId}`;
}

export default class EducationProgressService {
  savePosition(videoId: string, positionSeconds: number): void {
    if (!videoId || positionSeconds < 0) return;
    try {
      localStorage.setItem(storageKey(videoId), String(Math.round(positionSeconds)));
    } catch {
      // ignore
    }
  }

  getPosition(videoId: string): number | null {
    if (!videoId) return null;
    try {
      const v = localStorage.getItem(storageKey(videoId));
      if (v == null) return null;
      const n = parseFloat(v);
      return Number.isFinite(n) && n >= 0 ? n : null;
    } catch {
      return null;
    }
  }

  clearPosition(videoId: string): void {
    if (!videoId) return;
    try {
      localStorage.removeItem(storageKey(videoId));
    } catch {
      // ignore
    }
  }
}
